/**
 * Fits size to the remaining viewport area starting from position
 *
 * @param {number} position position in vw or vh
 * @param {number} size size in vw or vh
 * @param {number} bodySize the total size of the body along the dimension we're operating on, in vw or vh
 */
function fitDimensionToBody(position, size, bodySize) {
  if (position < 0) {
    return Math.max(size + position, 0);
  }
  bodySize = bodySize || 100;
  const distance_to_edge = bodySize-position;
  return Math.min(distance_to_edge, size);
}

/**
 * Returns a number in the interval [min, max)
 *
 * @param {number} min
 * @param {number} max
 */
function randomBetween(min, max) {
  return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer within the range [min, max)
 */
function getRandomInt(min, max) {
  return Math.floor(randomBetween(Math.ceil(min), Math.floor(max)));
}

const illuminati = "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/illuminati.webp";
const texture_bg_urls = [
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-1.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-field-strands-2.png",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  "https://cdn.shopify.com/s/files/1/0812/4216/1443/files/perlin-noise.webp",
  illuminati,
];

function makeSaltAndPepper(element, minWidth, maxWidth, minHeight, maxHeight) {
  return makeInvertRectangle(
    element,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    false
  );
}

function makeDisplacedInvertRectangle(
  element,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight
) {
  return makeInvertRectangle(
    element,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    true
  );
}

/**
 * Decorates the given element with an image which will be differenced over the page.
 * @param {HTMLDivElement} element The element to decorate.
 * @param {number} minWidth The minimum width of the rectangles created, in vw.
 * @param {number} maxWidth The maximum width of the rectangles created, in vw.
 * @param {number} minHeight The minimum height of the rectangles created, in vh.
 * @param {number} maxHeight The maximum height of the rectangles created, in vh.
 */
function makeInvertRectangle(
  element,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  displace
) {
  element.classList.add("cg-rectangle-invert");

  var width = randomBetween(minWidth, maxWidth);
  const left = randomBetween(-width, 100);
  width = fitDimensionToBody(left, width);

  // Top is in vh, but we need to account for the fact that the page is longer than the viewport.
  const bodyHeightVh = document.body.scrollHeight / window.innerHeight * 100;
  const top = Math.random() * (bodyHeightVh);
  const height = fitDimensionToBody(top, randomBetween(minHeight, maxHeight), bodyHeightVh);


  element.style.left = `${left}vw`;
  element.style.top = `${top}vh`;
  element.style.width = `${width}vw`;
  element.style.height = `${height}vh`;
  element.style.filter = `${displace ? `url(#glitch-shift) ` : ''}hue-rotate(${getRandomInt(0, 360)}deg)`;

  const bg_image = document.createElement("img");
  bg_image.classList.add("cg-rectangle-bg");
  bg_image.src = texture_bg_urls[getRandomInt(0, texture_bg_urls.length)];

  // Select a random subset of the image to display.
  const naturalHeight = bg_image.naturalHeight;
  const naturalWidth = bg_image.naturalWidth;
  const naturalAspectRatio = naturalWidth / naturalHeight;
  const containerHeight = element.clientHeight;
  const containerWidth = element.clientWidth;
  const containerAspectRatio = containerWidth / containerHeight;

  const maxHorzTranslate = (containerAspectRatio / naturalAspectRatio) * 100;
  const horzTranslate = -Math.random() * maxHorzTranslate;
  const maxVertTranslate = (naturalAspectRatio / containerAspectRatio) * 100;
  const vertTranslate = -Math.random() * maxVertTranslate;
  bg_image.style.transform = `translate(${horzTranslate}%, ${vertTranslate}%)`;

  element.appendChild(bg_image);
  return element;
}

function makeFullScreenInvert(
  element,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight
) {
  element.classList.add("cg-rectangle-invert");
  element.id = "cg-full-screen-invert";
  element.style.width = `${100}vw`;
  element.style.height = `${100}vh`;
  element.style.left = "0";
  element.style.top = "0";

  // Turn the background black.
  element.style.backgroundColor = "rgb(var(--color-background))";
  return element;
}

function makeIlluminati(element, minWidth, maxWidth, minHeight, maxHeight) {
  console.log(`illuminati with ${minWidth}, ${maxWidth}`);
  const left = Math.random() * 100;
  element.style.left = `${left}vw`;

  const size = fitDimensionToBody(left, randomBetween(minWidth, maxWidth));
  console.log(size)
  element.style.width = `${size}vw`;
  element.style.height = `${size}vw`;

  const topBarNodes = document.querySelectorAll('div[id$=header], div[id$=announcement-bar]');
  const topBarHeight = topBarNodes.item(0).clientHeight + topBarNodes.item(1).clientHeight;
  const sizePx = size / 100 * window.innerWidth;
  const top = randomBetween(topBarHeight, window.innerHeight - sizePx);
  element.style.top = `${top}px`;

  const bg_image = document.createElement("img");
  bg_image.classList.add("cg-rectangle-bg");
  bg_image.src = illuminati;
  bg_image.style.objectFit = "contain";

  element.appendChild(bg_image);

  return element;
}

/**
 * A manager for rectangles of a particular type for creating a particle system of filters.
 * Rectangles don't move, but they are created and destroyed over time.
 *
 * @param {object} config The configuration for the emitter.
 *
 * The config has the following properties:
 *
 * @param {number} minWidth The minimum width of the rectangles created, in vw.
 * @param {number} maxWidth The maximum width of the rectangles created, in vw.
 * @param {number} minHeight The minimum height of the rectangles created, in vh.
 * @param {number} maxHeight The maximum height of the rectangles created, in vh.
 * @param {number} minLifetime The minimum lifetime of the rectangles created, in seconds.
 * @param {number} maxLifetime The maximum lifetime of the rectangles created, in seconds.
 * @param {number} maxRectangles The maximum number of rectangles that can be created.
 * @param {function} rectangleDecorator A decorator function which takes a rectangle and returns a decorated rectangle.
 * @param {number} eagerness The eagerness of the emitter. The higher the eagerness, the more likely it is to create a rectangle.  0 is never, 1 is as soon as there's capacity.
 * @param {boolean} clearRectangles Whether to clear rectangles after they've been alive for their full lifetime.  Mostly for testing purposes.
 */
class RectangleEmitter {
  constructor(config) {
    this.minWidth = config.minWidth;
    this.maxWidth = config.maxWidth;
    this.minHeight = config.minHeight;
    this.maxHeight = config.maxHeight;
    this.minLifetime = config.minLifetime;
    this.maxLifetime = config.maxLifetime;
    this.maxRectangles = config.maxRectangles;
    this.rectangleDecorator = config.rectangleDecorator;
    this.eagerness = config.eagerness;
    this.clearRectangles = config.clearRectangles;
    this.rectangles = {};
    this._rectangle_count = 0;
    this._loop = undefined;
  }

  makeRectangle() {
    var rectangle = document.createElement("div");
    rectangle.classList.add("cg-rectangle");
    rectangle = this.rectangleDecorator(
      rectangle,
      this.minWidth,
      this.maxWidth,
      this.minHeight,
      this.maxHeight
    );
    document.body.appendChild(rectangle);

    if (this.clearRectangles) {
      const animationDuration =
      Math.random() * (this.maxLifetime - this.minLifetime) +
      this.minLifetime;
      const timeout = setTimeout(() => {
        this._clearRectangle(timeout);
      }, animationDuration * 1000);
      this.rectangles[timeout] = rectangle;;
    } else {
      // This will never overlap with a timeout id.
      this.rectangles[randomBetween(0.01, 1)] = rectangle;
    }
  }

  _clearRectangle(rectNum) {
    const rectangle = this.rectangles[rectNum];
    document.body.removeChild(rectangle);
    delete this.rectangles[rectNum];
  }

  start() {
    this._loop = setInterval(() => {
      const toss = Math.random();
      if (
        toss < this.eagerness &&
        Object.keys(this.rectangles).length < this.maxRectangles
      ) {
        this.makeRectangle();
      }
    }, 1);
  }

  stop() {
    this.pause();
    for (const rectNum in this.rectangles) {
      this._clearRectangle(rectNum)
    }
  }

  pause() {
    clearInterval(this._loop);
    for (const timeoutId in this.rectangles) {
      clearTimeout(timeoutId);
    }
  }
}

const emitters = [
  // wide and thin 'scratches on the film'
  new RectangleEmitter({
    minWidth: 25,
    maxWidth: 100,
    minHeight: .1,
    maxHeight: .2,
    minLifetime: 0.1,
    maxLifetime: 0.2,
    maxRectangles: 500,
    rectangleDecorator: makeDisplacedInvertRectangle,
    eagerness: .8,
    clearRectangles: true,
  }),
  new RectangleEmitter({
    minWidth: .3,
    maxWidth: .5,
    minHeight: 25,
    maxHeight: 100,
    minLifetime: 0.1,
    maxLifetime: 0.2,
    maxRectangles: 500,
    rectangleDecorator: makeDisplacedInvertRectangle,
    eagerness: .8,
    clearRectangles: true,
  }),
  // random glitched out 'dead pixel blocks'
  new RectangleEmitter({
    minWidth: 3,
    maxWidth: 8,
    minHeight: 1,
    maxHeight: 2,
    minLifetime: 0.3,
    maxLifetime: 0.8,
    maxRectangles: 15,
    rectangleDecorator: makeDisplacedInvertRectangle,
    eagerness: .6,
    clearRectangles: true,
  }),
  // salt and pepper noise
  new RectangleEmitter({
    minWidth: .2,
    maxWidth: .25,
    minHeight: .2,
    maxHeight: .25,
    minLifetime: 0.2,
    maxLifetime: 0.3,
    maxRectangles: 1500,
    rectangleDecorator: makeSaltAndPepper,
    eagerness: 1,
    clearRectangles: true,
  }),
  // flashing full screen invert
  new RectangleEmitter({
    minWidth: 200,
    maxWidth: 200,
    minHeight: 200,
    maxHeight: 200,
    minLifetime: .25,
    maxLifetime: .75,
    maxRectangles: 1,
    rectangleDecorator: makeFullScreenInvert,
    eagerness: .0035,
    clearRectangles: true,
  }),
  // flashing all-knowing eye
  new RectangleEmitter({
    minWidth: 8,
    maxWidth: 5,
    minLifetime: .15,
    maxLifetime: .15,
    maxRectangles: 1,
    rectangleDecorator: makeIlluminati,
    eagerness: .002,
    clearRectangles: true,
  })
];

emitters.forEach((emitter) => emitter.start());
